module.exports = __webpack_public_path__ + "img/loader.2ae1f88a.gif";